import React from 'react'
import LoginBasic from 'components/Page/Login/LoginBasic'

import useSignup from 'logic/Login/useSignup'

const i18nCategory = 'signup'
const Signup = () => {
    return <LoginBasic i18nCategory={i18nCategory} useAction={useSignup} />
}

export default Signup
